<template>
      <div class="">
        <!-- {{question_detail}} -->
        <div
          v-for="(each_link, link_index) in question_detail.links"
          :key="link_index"
        >
          <div class="">
            <div class="add_links_option"
            v-if="type !== 'Import'">
            <vs-input
              v-model="question_detail.links[link_index]"
              :name="`links_${link_index}`"
              :data-vv-name="`links_${link_index}`"
              label-placeholder="Add your link here"
              @keydown.space.prevent
              style="width:90%;margin-top:25px;margin-right:5px;display:inline-block"
            />

            <vs-button v-if="link_index !== 0"
              style="display:inline-block"
              color="dark"
              type="filled"
              icon="close"
              @click="removeCurrectLink(question_detail, link_index)"
            >
            </vs-button>
            </div>

            <!-- Preview for youtube videos -->
            <div class="" v-if="each_link !== ''">
              <br />
              <div
                class=""
                v-if="
                  each_link.includes('youtube') ||
                    each_link.includes('youtu.be')
                "
              >
                <iframe
                  class="links-video"
                  :src="checkVideoLink(each_link)"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
                <!-- {{checkVideoLink(each_link)}} -->
              </div>
            </div>

            <!-- Preview for vimeo videos -->
            <div class="" v-if="each_link !== ''">
              <br />
              <div class="" v-if="each_link.includes('vimeo')">
                <iframe
                  class="links-video"
                  :src="checkVideoLink(each_link)"
                  frameborder="0"
                  allow="autoplay; fullscreen"
                  allowfullscreen
                ></iframe>
                <!-- {{checkVideoLink(each_link)}} -->
              </div>
            </div>
          </div>
        </div>
        </div>
</template>
<script>
export default {
  name: 'LinkPreviewComponent',
  props: ['question_detail', 'type'],
  components: {},
  mixins: [],
  mounted () {
    if (this.type === 'Import') {
      this.question_detail.links = (this.question_detail.links.length > 0) ? this.question_detail.links.map((url) => { return url.url }) : ['']
    }
  },
  data () {
    return {
    }
  },
  watch: {},
  methods: {
    checkVideoLink (videoLink) {
      if (videoLink.includes('watch?v=')) {  
        return `${videoLink.split('watch?v=')[0]}embed/${videoLink.split('watch?v=')[1]}`
      } else if (videoLink.includes('https://youtu.be')) {
        return `https://youtube.com/embed${videoLink.split('https://youtu.be')[1]}`
      } else if (!videoLink.includes('player.vimeo.com')) {
        return `https://player.vimeo.com/video/${videoLink.split('vimeo.com/')[1]}`
      } else {
        return videoLink
      }
    },
    removeCurrectLink (question_detail, link_index) {
      const removeLinkObj = {
        question_detail,
        link_index
      }
      this.$emit('removeLinkEvent', removeLinkObj)
    }
  }
}
</script>
